export default __webpack_public_path__ + "static/media/WispLogo.17446d8f.png";